import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HardHatIcon, FactoryIcon, HeartPulseIcon, WheatIcon, WifiIcon, ZapIcon, ShoppingBagIcon } from 'lucide-react';
export function Products() {
  const sectors = [{
    icon: HardHatIcon,
    title: 'Construction Materials',
    description: 'Cement, steel, aggregates, prefab structures, and building equipment'
  }, {
    icon: FactoryIcon,
    title: 'Industrial Equipment',
    description: 'Manufacturing machinery, processing equipment, and industrial tools'
  }, {
    icon: HeartPulseIcon,
    title: 'Medical Supplies',
    description: 'Pharmaceuticals, diagnostic equipment, hospital furniture, and consumables'
  }, {
    icon: WheatIcon,
    title: 'Agricultural Products',
    description: 'Farm equipment, irrigation systems, fertilizers, and agro-processing machinery'
  }, {
    icon: WifiIcon,
    title: 'ICT & Telecommunications',
    description: 'Network infrastructure, mobile devices, and telecommunications equipment'
  }, {
    icon: ZapIcon,
    title: 'Energy & Infrastructure',
    description: 'Power generation equipment, solar systems, and electrical infrastructure'
  }, {
    icon: ShoppingBagIcon,
    title: 'Consumer & Commercial Goods',
    description: 'FMCG, food and beverages, household and personal care, apparel, homeware, and general merchandise for retail chains, hypermarkets, and institutional buyers'
  }];
  return <section id="sectors" className="py-24 px-6 bg-navy-light" data-id="element-211">
      <div className="max-w-7xl mx-auto" data-id="element-212">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-213">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-214">
            <div className="w-12 h-px bg-gold" data-id="element-215"></div>
            <span className="text-gold text-xs font-semibold tracking-widest uppercase" data-id="element-216">
              Sectors We Serve
            </span>
            <div className="w-12 h-px bg-gold" data-id="element-217"></div>
          </div>
          <h2 className="text-4xl lg:text-5xl font-semibold text-white mb-4" data-id="element-218">
            Procurement Across All Major Sectors
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-219">
            Comprehensive sourcing capabilities for institutional and commercial
            procurement programmes
          </p>
        </motion.div>

        {/* Sectors Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-12" data-id="element-220">
          {sectors.map((sector, i) => <motion.div key={sector.title} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-navy-dark border border-slate-800 hover:border-gold/50 p-8 rounded-lg transition-all group text-center" data-id="element-221">
              <div className="w-16 h-16 bg-gold/10 border border-gold/30 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-gold/20 transition-colors" data-id="element-222">
                <sector.icon size={28} className="text-gold" data-id="element-223" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-2" data-id="element-224">
                {sector.title}
              </h3>
              <p className="text-slate-400 text-sm" data-id="element-225">{sector.description}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-226">
          <Link to="/sectors" className="inline-block bg-gold hover:bg-gold-dark text-navy-dark px-8 py-3 rounded-md font-semibold text-sm transition-colors" data-id="element-227">
            View All Sectors
          </Link>
        </motion.div>
      </div>
    </section>;
}